import { render } from "./CreatePaymentLiquidation2.vue?vue&type=template&id=09537120"
import script from "./CreatePaymentLiquidation2.vue?vue&type=script&lang=js"
export * from "./CreatePaymentLiquidation2.vue?vue&type=script&lang=js"

import "./CreatePaymentLiquidation2.vue?vue&type=style&index=0&id=09537120&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__